import { AnimatedLink } from "@/components/common/animated-link"
import { ButtonToTop } from "@/components/footer/button-to-top"

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer
      className={`
        relative
        py-8 px-6 md:pl-24 md:pr-[70px] md:pt-12 md:pb-10
        border-t border-main
        grid grid-cols-1 md:grid-cols-[auto_auto]
        md:grid-rows-[repeat(3,auto)]
        gap-y-7 md:gap-y-10
      `}
    >
      <nav
        className={`
          md:row-start-1
          md:col-start-2
          flex flex-col md:flex-row
          md:justify-end
          gap-y-4 lg:gap-x-10 md:gap-x-[3vw]
          text-[14px] md:text-[16px]
          leading-[1] font-bold
        `}
      >
        <AnimatedLink to="/about">About us</AnimatedLink>
        <AnimatedLink to="/service">Service</AnimatedLink>
        <AnimatedLink to="/news">News</AnimatedLink>
        <AnimatedLink to="/recruit">Recruit</AnimatedLink>
        <AnimatedLink to="https://share.hsforms.com/1HGVjUue-TECLD2HOytVUcwdwtzz">
          Contact
        </AnimatedLink>
      </nav>

      <a
        className={`
          h-[14px] object-contain
          w-[54px] mx-0.5 md:w-16 md:mx-1
          md:row-start-2 md:col-start-2
          md:justify-self-end
        `}
        href="https://note.com/kotaeruhr_pr/"
        target="_blank"
        rel="noreferrer"
      >
        <img src="/images/common/logo_note.svg" alt="note" />
      </a>

      <nav className="md:-mt-4 md:row-start-3 md:col-start-2 md:justify-self-end">
        <ul
          className={`
            flex flex-col md:flex-row
            gap-y-3 md:gap-y-9 gap-x-6
            text-[12px] leading-[1]
          `}
        >
          <li>
            <AnimatedLink to="/privacypolicy" lineGapPixel={2}>
              プライバシーポリシー
            </AnimatedLink>
          </li>
          <li>
            <AnimatedLink to="/personal-information" lineGapPixel={2}>
              当社における個人情報の取り扱いについて
            </AnimatedLink>
          </li>
          <li>
            <AnimatedLink
              to="https://trust.kotaeru.co.jp"
              target="_blank"
              lineGapPixel={2}
            >
              コタエル信託
              <span>
                <img
                  src="/images/common/icon_external_lp.svg"
                  alt="「外部リンクを開く」のアイコン"
                  className="w-3 h-auto inline-block align-middle mt-[-3px] ml-1"
                />
              </span>
            </AnimatedLink>
          </li>
        </ul>
      </nav>

      <div className="flex items-center">
        <img
          src="/images/common/logo_kotaeru.svg"
          alt="コタエルHR"
          className="w-24 md:w-44 md:row-start-1 md:col-start-1"
        />
      </div>

      <a
        href="https://privacymark.jp"
        target="_blank"
        rel="noreferrer"
        className="size-10 md:size-[72px] md:row-start-2 md:col-start-1"
      >
        <img src="/images/common/pmark.png" alt="pマーク" />
      </a>

      <small className="text-[12px] -mt-4 md:-mt-4 md:row-start-3 md:col-start-1">
        &copy; {year} KOTAERU HR
      </small>

      <a
        className={`
          absolute
          top-0 -translate-y-1/2
          right-6 md:right-20
          z-10
          p-1
          bg-white
          md:hover-opaque
        `}
        href="#top"
      >
        <ButtonToTop />
      </a>
    </footer>
  )
}
